import { IconProps } from './types'

export const Tick = ({ className }: IconProps) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.3957 6.30068C19.8922 6.7396 19.939 7.49796 19.5 7.99452L11.0143 17.5945C10.7938 17.844 10.4796 17.9906 10.1467 17.9994C9.8139 18.0081 9.49239 17.8782 9.25909 17.6406L4.5448 12.8406C4.08041 12.3678 4.08726 11.608 4.56009 11.1436C5.03292 10.6793 5.79269 10.6861 6.25708 11.1589L10.069 15.0402L17.7018 6.40504C18.1408 5.90848 18.8991 5.86176 19.3957 6.30068Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.522 6.24609C18.0487 5.65022 18.9588 5.59415 19.5546 6.12086C20.1505 6.64757 20.2066 7.5576 19.6799 8.15347L11.1941 17.7535C10.9295 18.0528 10.5524 18.2288 10.153 18.2393C9.75363 18.2498 9.36782 18.0939 9.08786 17.8088L4.37357 13.0088C3.81631 12.4414 3.82452 11.5297 4.39192 10.9724C4.95932 10.4152 5.87104 10.4234 6.4283 10.9908L10.0598 14.6882L17.522 6.24609ZM10.069 15.0402L6.25708 11.1589C5.79269 10.6861 5.03292 10.6793 4.56009 11.1436C4.08726 11.608 4.08041 12.3678 4.5448 12.8406L9.25909 17.6406C9.49239 17.8782 9.8139 18.0081 10.1467 17.9994C10.4796 17.9906 10.7938 17.844 11.0143 17.5945L19.5 7.99452C19.939 7.49796 19.8922 6.7396 19.3957 6.30068C18.8991 5.86176 18.1408 5.90848 17.7018 6.40504L10.069 15.0402Z'
        fill='currentColor'
      />
    </svg>
  )
}
